export default __webpack_public_path__ + "static/patriots-cbb732e8fde465bb1ff428212c621755.png";